import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            精选动漫内容，一次看个够
          </p>
        </div>

        {/* Static display - all items visible, no carousel behavior */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.slice(0, 2).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-3 py-1 bg-black/55 text-white text-xs rounded-full whitespace-nowrap backdrop-blur-sm">
                  {item.stats}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Second row for the remaining 3 items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselData.slice(2, 5).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-3 py-1 bg-black/55 text-white text-xs rounded-full whitespace-nowrap backdrop-blur-sm">
                  {item.stats}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}